var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5007 8.5943C20.4532 8.48577 20.3869 8.38655 20.3047 8.3013L14.3047 2.3013C14.2194 2.21908 14.1202 2.15271 14.0117 2.1053C13.9817 2.0913 13.9497 2.0833 13.9177 2.0723C13.834 2.04383 13.7469 2.02667 13.6587 2.0213C13.6377 2.0193 13.6187 2.0083 13.5977 2.0083H6.59766C5.49466 2.0083 4.59766 2.9053 4.59766 4.0083V20.0083C4.59766 21.1113 5.49466 22.0083 6.59766 22.0083H18.5977C19.7007 22.0083 20.5977 21.1113 20.5977 20.0083V9.0083C20.5977 8.9873 20.5867 8.9683 20.5847 8.9463C20.5798 8.85802 20.5626 8.77085 20.5337 8.6873C20.5237 8.6553 20.5147 8.6243 20.5007 8.5943ZM17.1837 8.0083H14.5977V5.4223L17.1837 8.0083ZM6.59766 20.0083V4.0083H12.5977V9.0083C12.5977 9.27352 12.703 9.52787 12.8905 9.71541C13.0781 9.90294 13.3324 10.0083 13.5977 10.0083H18.5977L18.5997 20.0083H6.59766Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5977 20.9318L11.5977 12.9318L13.5977 12.9318L13.5977 20.9318L11.5977 20.9318Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00536 16.3459L12.6914 10.5972L12.6909 13.8345L9.54394 17.6237L8.00536 16.3459Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2837 16.3459L12.5977 10.5972L12.5982 13.8345L15.7451 17.6237L17.2837 16.3459Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.1881a30bdf61120bf04e235b315fd58a.svg";
export { ForwardRef as ReactComponent };